import axiosInstance from "./axios";
import { imageCompressorFn } from "./utils";

export interface FileUploadResponse {
  success: boolean;
  url: string;
  message?: string;
}

export interface FileUploadOptions {
  folder?: string;
  allowedTypes?: string[];
  maxSize?: number; // in bytes
}

/**
 * Custom file uploader function that uploads file to backend and returns URL
 * @param file - File object to upload
 * @param options - Upload options (folder, allowed types, max size)
 * @returns Promise<FileUploadResponse> - Response with URL
 */
export const uploadFile = async (
  file: File,
  options: FileUploadOptions = {}
): Promise<FileUploadResponse> => {
  try {
    // Validate file
    if (!file) {
      throw new Error("No file provided");
    }

    // Check file type if allowed types are specified
    // if (options.allowedTypes && options.allowedTypes.length > 0) {
    //   const fileType = file.type;
    //   const isAllowed = options.allowedTypes.some(
    //     (type) =>
    //       fileType.includes(type) || file.name.toLowerCase().endsWith(type)
    //   );

    //   if (!isAllowed) {
    //     throw new Error(
    //       `File type not allowed. Allowed types: ${options.allowedTypes.join(
    //         ", "
    //       )}`
    //     );
    //   }
    // }

    // Check file size if max size is specified
    if (options.maxSize && file.size > options.maxSize) {
      const maxSizeMB = (options.maxSize / (1024 * 1024)).toFixed(2);
      throw new Error(`File size exceeds limit of ${maxSizeMB}MB`);
    }

    // Create FormData
    let newFile = null;
    await imageCompressorFn(file, (comFile: any) => {
      newFile = comFile;
      console.log(comFile,"comFilecomFilecomFile")
    });
    const formData = new FormData();
    formData.append("image", newFile ? newFile : file);

    if (options.folder) {
      formData.append("folder", options.folder);
    }

    // Make API call to backend
    const response = await axiosInstance.post("/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    // Return success response with URL
    return {
      success: true,
      url:
        response?.data?.data?.url ||
        response?.data?.data?.fileUrl ||
        response?.data?.data?.path,
      message: response?.data?.data?.message || "File uploaded successfully",
    };
  } catch (error: any) {
    console.error("File upload error:", error);

    // Handle different error types
    if (error.response) {
      // Server responded with error status
      return {
        success: false,
        url: "",
        message:
          error.response.data?.message ||
          error.response.data?.error ||
          "Upload failed",
      };
    } else if (error.request) {
      // Network error
      return {
        success: false,
        url: "",
        message: "Network error. Please check your connection.",
      };
    } else {
      // Other errors (validation, etc.)
      return {
        success: false,
        url: "",
        message: error.message || "Upload failed",
      };
    }
  }
};
